export const urlFriendly = (input) => {
  return input
    .replace(/[^a-z0-9_]+/gi, '-')
    .replace(/^-|--+|-$/g, '')
    .toLowerCase();
};
